<template>
  <!-- record -->
  <div class="receipt" id="receipt" style="font-size: 12px;font-family:宋体;">
    <h3 style="text-align: center; font-size: 14px;">{{$store.state.global.countInfo.hospitalName}}</h3>
    <h4 style="text-align: center;font-family:宋体; font-size: 12px;margin-top: -10px;">收费清单</h4>
    <div class="header-info" style="border-bottom: 1px dashed #000000;padding-bottom: 10px;">
      <div style="font-size: 12px;">收费时间：{{feeTime}}</div>
      <div style="font-size: 12px;">收费员：{{viewScript.cashier || $store.state.global.countInfo.realName}}</div>
      <div style="font-size: 12px;" v-if="printConfig.printPatientName">姓名：{{viewScript.patientName}}</div>
    </div>
    <div class="sale" v-if="isSale" style="font-size: 12px;">
      <div class="script" v-if="viewScript.saleDrugPrescriptionList && viewScript.saleDrugPrescriptionList.items.length > 0" style="border-bottom: 1px dashed #000000;clear:both;">
        <div style="">
          <div>药品名称</div>
          <div class="sub-header flex" style="padding-bottom:0px;">
            <div style="float: left;width: 33.33%;">单价</div>
            <div style="float: left;width: 33.33%;text-align: center;">数量</div>
            <div style="float: left;width: 33.33%;text-align: right;">金额</div>
          </div>
          <div style="clear: both;"></div>
          <div style="border-bottom: 1px dashed #000000;"></div>
        </div>
        <div class="sub-body0" style="padding: 0px 0px;" v-for="item in viewScript.saleDrugPrescriptionList.items" :key="item.drugId">
          <div>{{item.drugName}}</div>
          <div style="">
            <div style="float: left;width: 33.33%;">{{item.salePrice}}</div>
            <div style="float: left;width: 33.33%;text-align: center;">{{item.dosage}} {{item.saleUnit}}</div>
            <div style="float: left;width: 33.33%;text-align: right;">{{drugAmt(item.salePrice, item.dosage)}}</div>
          </div>
          <div style="clear: both;"></div>
        </div>
        <div style="clear: both;">
          <div style="text-align: right;">分计：{{viewScript.saleDrugPrescriptionList.receivableAmt}}</div>
        </div>
      </div>
      <div class="script" v-if="viewScript.orderExam && viewScript.orderExam.items.length > 0" style="border-bottom: 1px dashed #000000;">
        <div style="">
          <div>检查治疗项</div>
          <div class="sub-header flex" style="padding-bottom:0px;">
            <div style="float: left;width: 33.33%;">单价</div>
            <div style="float: left;width: 33.33%;text-align: center;">数量</div>
            <div style="float: left;width: 33.33%;text-align: right;">金额</div>
          </div>
          <div style="clear: both;"></div>
          <div style="border-bottom: 1px dashed #000000;"></div>
        </div>
        <div class="sub-body0" style="padding: 0px 0px;" v-for="item in viewScript.orderExam.items" :key="item.drugId">
          <div>{{item.drugName}}</div>
          <div style="">
            <div style="float: left;width: 33.33%;">{{item.salePrice}}</div>
            <div style="float: left;width: 33.33%;text-align: center;">{{item.count}}次</div>
            <div style="float: left;width: 33.33%;text-align: right;">{{drugAmt(item.salePrice, item.count)}}</div>
          </div>
          <div style="clear: both;"></div>
        </div>
        <div>
          <div style="text-align: right;">分计：{{viewScript.orderExam.receivableAmt}}</div>
        </div>
      </div>
      <div class="script" v-if="viewScript.orderAddition && viewScript.orderAddition.items.length > 0" style="border-bottom: 1px dashed #000000;clear:both;">
        <div style="">
          <div class="sub-header flex" style="padding-bottom:20px;">
            <div style="float: left;width: 50%;">附加费名称</div>
            <div style="float: left;width: 50%;text-align: right;">金额</div>
          </div>
          <div style="clear: both;"></div>
          <div style="border-bottom: 1px dashed #000000;"></div>
        </div>
        <div class="sub-body0" style="padding: 0px 0px;" v-for="item in viewScript.orderAddition.items" :key="item.drugId">
          <div style="">
            <div style="float: left;width: 50%;">{{item.amtName}}</div>
            <div style="float: left;width: 50%;text-align: right;">{{item.salePrice}}</div>
          </div>
          <div style="clear: both;"></div>
        </div>
        <div style="clear: both;">
            <div style="text-align: right;">分计：{{viewScript.orderAddition.receivableAmt}}</div>
          </div>
      </div>
    </div>
    <div class="medical-record" v-else style="font-size: 12px;">
      <div class="script" v-if="viewScript.saleDrugPrescriptionList && viewScript.saleDrugPrescriptionList.length > 0" style="border-bottom: 1px dashed #000000;clear:both;">
        <div style="">
          <div>成药名称</div>
          <div class="sub-header flex" >
            <span style="float: left;width: 33.33%;">单价</span>
            <span style="float: left;width: 33.33%;text-align: center;">数量</span>
            <span style="float: left;width: 33.33%;text-align: right;">金额</span>
          </div>
          <div style="clear: both;"></div>
          <div style="border-bottom: 1px dashed #000000;"></div>
        </div>
        <div v-for="(item, index) in viewScript.saleDrugPrescriptionList" :key="index">
          <div>成药处方 {{index + 1}}</div>
          <div class="sub-body0" style="padding: 0px 0px;" v-for="it in item.items" :key="it.drugId">
            <div>{{it.drugName}}</div>
            <div style="align-items: center;">
              <div style="float: left;width: 33.33%;">{{it.salePrice}}</div>
              <div style="float: left;width: 33.33%;text-align: center;">{{it.dosage}} {{it.saleUnit}}</div>
              <div style="float: left;width: 33.33%;text-align: right;">{{drugAmt(it.salePrice, it.dosage)}}</div>
            </div>
            <div style="clear: both;"></div>
          </div>
          <div style="clear: both;">
            <div style="text-align: right;">分计：{{item.receivableAmt}}</div>
          </div>
        </div>
      </div>
      <div class="script" v-if="viewScript.medicineDrugPrescriptionList && viewScript.medicineDrugPrescriptionList.length > 0" style="border-bottom: 1px dashed #000000;">
        <div style="margin: 0px 0px 8px 0;">
          <div>成药名称</div>
          <div class="sub-header" style="margin: 0px 0px;align-items: center;">
            <div style="float: left;width: 33.33%;">单价</div>
            <div style="float: left;width: 33.33%;text-align: center;">数量</div>
            <div style="float: left;width: 33.33%;text-align: right;">金额</div>
          </div>
          <div style="clear: both;"></div>
          <div style="border-bottom: 1px dashed #000000;"></div>
        </div>
        <div v-for="(item, index) in viewScript.medicineDrugPrescriptionList" :key="index" style="margin-bottom:8px;">
          <div>成药处方 {{index + 1}}</div>
          <div class="sub-body0" style="padding: 0px 0px;" v-for="it in item.items" :key="it.drugId">
            <div>{{it.drugName}}</div>
            <div style="align-items: center;">
              <div style="float: left;width: 33.33%;">{{it.salePrice}}</div>
              <div style="float: left;width: 33.33%;text-align: center;">{{it.dosage}} {{it.saleUnit}}</div>
              <div style="float: left;width: 33.33%;text-align: right;">{{drugAmt(it.salePrice, it.dosage)}}</div>
            </div>
            <div style="clear: both;"></div>
          </div>
          <div style="clear: both;">
            <div style="text-align: right;">分计：{{item.receivableAmt}}</div>
          </div>
        </div>
      </div>

      <!-- 饮片名称 -->
      <div class="script" v-if="viewScript.medicineDrugPrescriptionList && viewScript.patientChineseDrugList.length > 0" style="border-bottom: 1px dashed #000000;clear:both;">
        <div style="margin-bottom:8px;">
          <div>饮片名称</div>
          <div class="sub-header flex" style="padding-bottom: 0px;">
            <div style="float: left;width: 33.33%;">单价</div>
            <div style="float: left;width: 33.33%;text-align: center;">数量</div>
            <div style="float: left;width: 33.33%;text-align: right;">金额</div>
          </div>
          <div style="clear: both;"></div>
          <div style="border-bottom: 1px dashed #000000;"></div>
        </div>
        <div v-for="(item, index) in viewScript.patientChineseDrugList" :key="index" style="margin-bottom:8px;">
          <div>饮片处方 {{index + 1}}</div>
          <div style="align-items: center;">
            <div style="float: left;width: 33.33%;">{{chineseDrugPrice(item)}}</div>
            <div style="float: left;width: 33.33%;text-align: center;">{{item.items[0].dosage}}剂</div>
            <div style="float: left;width: 33.33%;text-align: right;">{{item.receivableAmt}}</div>
          </div>
          <div style="clear: both;"></div>
          <div class="sub-body0" style="padding: 0px 0px;">
            <span v-for="it in item.items" :key="it.drugId">
              {{it.drugName}}，
              <span v-if="printConfig.printDetails">{{it.dose}} {{it.saleUnit}}；</span>
            </span>
          </div>
          <div style="clear: both;">
            <div style="text-align: right;">分计：{{item.receivableAmt}}</div>
          </div>
        </div>
      </div>
      <!-- 输液卡名称 -->
      <div class="script" v-if="viewScript.patientInfusionList && viewScript.patientInfusionList.length > 0" style="border-bottom: 1px dashed #000000;clear:both;">
        <div style="margin-bottom:8px;">
            <div>输液名称</div>
            <div class="sub-header flex" style="padding-bottom:0px;">
              <div style="float: left;width: 33.33%;">单价</div>
              <div style="float: left;width: 33.33%;text-align: center;">数量</div>
              <div style="float: left;width: 33.33%;text-align: right;">金额</div>
            </div>
            <div style="clear: both;"></div>
            <div style="border-bottom: 1px dashed #000000;"></div>
          </div>
        <div v-for="(item, index) in viewScript.patientInfusionList" :key="index" style="margin-bottom:8px;">
          <div>输液卡处方 {{index + 1}}</div>
          <div class="sub-body0" style="padding: 0px 0px;" v-for="it in item.items" :key="it.drugId">
            <div>{{it.drugName}}</div>
            <div style="align-items: center;">
              <div style="float: left;width: 33.33%;">{{it.salePrice}}</div>
              <div style="float: left;width: 33.33%;text-align: center;">{{it.dosage}} {{it.saleUnit}}</div>
              <div style="float: left;width: 33.33%;text-align: right;">{{drugAmt(it.salePrice, it.dosage)}}</div>
            </div>
            <div style="clear: both;"></div>
          </div>
          <div style="clear: both;">
            <div style="text-align: right;">分计：{{item.receivableAmt}}</div>
          </div>
        </div>
      </div>
      <!-- 敷贴处方 -->
      <div class="script" v-if="viewScript.patientStickingDrugGroupList && viewScript.patientStickingDrugGroupList.length > 0" style="border-bottom: 1px dashed #000000;">
        <div style="margin-bottom:8px;">
            <div>敷贴名称</div>
            <div class="sub-header flex" style="padding-bottom:0px;">
              <div style="float: left;width: 33.33%;">单价</div>
              <div style="float: left;width: 33.33%;text-align: center;">数量</div>
              <div style="float: left;width: 33.33%;text-align: right;">金额</div>
            </div>
            <div style="clear: both;"></div>
            <div style="border-bottom: 1px dashed #000000;"></div>
          </div>
        <div v-for="(item, index) in viewScript.patientStickingDrugGroupList" :key="index" style="margin-bottom:8px;">
          <div>敷贴处方 {{index + 1}}</div>
          <div style="align-items: center;">
            <div style="float: left;width: 33.33%;">{{chineseDrugPrice(item)}}</div>
            <div style="float: left;width: 33.33%;text-align: center;">{{item.items[0].dosage}}贴</div>
            <div style="float: left;width: 33.33%;text-align: right;">{{item.receivableAmt}}</div>
          </div>
          <div>
            <span class="sub-body0" style="padding: 0px 0px;" v-for="it in item.items" :key="it.drugId">
              <span>{{it.drugName}}，<span v-if="printConfig.printDetails">{{it.dose}}{{it.saleUnit}}；</span></span>
            </span>
          </div>
          <div style="clear: both;">
            <div style="text-align: right;">分计：{{item.receivableAmt}}</div>
          </div>
        </div>
      </div>
      <!-- 检查治疗项 -->
      <div class="script" v-if="viewScript.orderExam && viewScript.orderExam.length > 0" style="border-bottom: 1px dashed #000000;">
        <div style="margin-top: 0px;margin-bottom: 0px;">
          <div>检查治疗项名称</div>
          <div class="sub-header" style="padding-bottom:0px;">
            <div style="float: left;width: 33.33%;">单价</div>
            <div style="float: left;width: 33.33%;text-align: center;">数量</div>
            <div style="float: left;width: 33.33%;text-align: right;">金额</div>
          </div>
          <div style="clear: both;"></div>
          <div style="border-bottom: 1px dashed #000000;"></div>
        </div>
        <div v-for="(item, index) in viewScript.orderExam" :key="index" style="margin-bottom:4px;">
          <div v-for="it in item.items" :key="it.id">
            <div>{{it.drugName}}</div>
            <div style="">
              <div style="float: left;width: 33.33%;">{{it.salePrice}}</div>
              <div style="float: left;width: 33.33%;text-align: center;">{{it.dosage}}次</div>
              <div style="float: left;width: 33.33%;text-align: right;">{{drugAmt(it.salePrice, it.dosage)}}</div>
            </div>
          </div>
          <div>
            <div style="text-align: right;">分计：{{item.receivableAmt}}</div>
          </div>
        </div>
      </div>
      <!-- 附加费用 -->
      <div class="script" v-if="viewScript.orderAddition && viewScript.orderAddition.length > 0" style="border-bottom: 1px dashed #000000;">
        <div style="margin-top: 2px;margin-bottom:8px;">
          <div class="sub-header flex" style="padding-bottom:0px;">
            <div style="float: left;width: 50%;">附加费用名称</div>
            <div style="float: left;width: 50%;text-align: right;">金额</div>
          </div>
          <div style="clear: both;"></div>
          <div style="border-bottom: 1px dashed #000000;"></div>
        </div>
        <div v-for="(item, index) in viewScript.orderAddition" :key="index" style="margin-bottom:8px;">
          <div v-for="it in item.items" :key="it.id">
            <div style="align-items: center;">
              <div style="float: left;width: 50%;">{{it.drugName}}</div>
              <div style="float: left;width: 50%;text-align: right;">{{it.salePrice}}</div>
            </div>
            <div style="clear: both;"></div>
          </div>
          <div style="clear: both;">
            <div style="text-align: right;">分计：{{item.receivableAmt}}</div>
          </div>
        </div>
      </div>
    </div>
    <div style="text-align: right;padding-top:10px;padding-bottom: 10px; border-bottom: 1px solid #AAAAAA;font-size: 12px;">
      <div>合计：￥{{viewScript.receivableAmt}}</div>
      <div>优惠：￥{{viewScript.totalDiscountAmt}}</div>
      <div>实收：<span style="font-size: 16px;">￥{{viewScript.actualReceivableAmt}}</span></div>
    </div>
    <div style="text-align: center; line-height: 30px;font-size: 10px;">{{printConfig.remark}}</div>
    <div style="text-align: center; font-size: 10px;">打印时间：{{chargingTime}}</div>
  </div>
</template>

<script>
import { BigNumber } from 'bignumber.js';
import moment from 'moment';
import { getLodop } from '@/plugins/LodopFuncs.js';

const BN = BigNumber.clone();
BN.config({ DECIMAL_PLACES: 2 });

export default {
  props: {
    // script 需要传入的数据
    script: {
      type: Object,
      default: {
        medicineDrugPrescriptionList: {}, // 成药
        patientChineseDrugList: {}, // 中药处方
        patientInfusionList: {}, // 输液处方
        patientStickingDrugGroupList: {}, // 贴敷处方
        orderExam: {}, // 检查治疗项
        orderAddition: {}, // 附加费用
        receivableAmt: '', // 合计
        totalDiscountAmt: '', // 优惠
        actualReceivableAmt: '', // 实收
      },
    },
    // 是否是直接售药的数据结构
    isSale: {
      type: Boolean,
      default: false,
    },
    isReview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      printConfig: {
        paperWidth: 80,
        printDetails: '',
        printPatientName: '',
      },
      hospitalName: '',
      chargingTime: '',
      feeTime: '', // 收费时间
      viewScript: {},
    }
  },
  methods: {
    print({isReview} = {}) {
      console.log('====================================');
      console.log(this.script);
      console.log('====================================');
      this.feeTime = this.script.createDate ? this.script.createDate : moment().format('YYYY-MM-DD HH:mm:ss');
      this.chargingTime = moment().format('YYYY-MM-DD HH:mm:ss');
      const { medicineValue } = this.$store.state.global.printConfig;
      this.$nextTick(() => {
        const LODOP = getLodop();
        LODOP.SET_LICENSES("","94E6E7FFD51B8CCBE5F216686981579D","C94CEE276DB2187AE6B65D56B3FC2848","");
        LODOP.PRINT_INIT('小票打印');
        const pageWith = this.printConfig.paperWidth == 80 ? 790 : 570;
        LODOP.SET_PRINT_PAGESIZE(3, pageWith, '30mm', '小票打印'); // 这里3表示纵向打印且纸高“按内容的高度”；1385表示纸宽138.5mm；45表示页底空白4.5mm
        LODOP.ADD_PRINT_HTM(0, 5, "100%", "100%", document.getElementById("receipt").innerHTML);
        LODOP.SET_PRINTER_INDEX(medicineValue);
        LODOP.SET_PRINT_MODE("RESELECT_PAGESIZE", true); // 可以自行修改打印尺寸
        LODOP.SET_PRINT_MODE("AUTO_CLOSE_PREWINDOW", 1); // 打印后自动关闭预览窗口
        LODOP.PREVIEW();
        // 关闭打印触发事件
        LODOP.On_Return = (taskId, value) => {
          this.$emit('reviewClose');
        }
      });
    },
    // 计算金额
    drugAmt(price, num) {
      return BN(price).multipliedBy(num).toFixed(3);
    },
    
    // 获取打印配置
    getPrintConfig() {
      this.$api.clinicManagement.getPrintConfit({configType: 5}).then((res) => {
        this.printConfig = res;
      })
    },
    chineseDrugPrice(item) {
      console.log(item.items[0]);
      
      return BN(item.receivableAmt).dividedBy(item.items[0].dosage).toFixed(3);
    }
  },
  computed: {
    laboratoryName() {
       return this.$store.state.global.countInfo.laboratoryName;
    },
  },
  watch: {
    script(val) {
      this.viewScript = val;
    }
  },
  mounted() {
    this.getPrintConfig();
  }
}
</script>
<style lang="scss" scoped>
.header-info {
  border-bottom: 2px solid #000000;
}
.receipt {
  width: 300px;
  justify-content: space-between;
}
span {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: #AAAAAA;
}
.receipt {
  position: fixed;
  background: white;
  
  z-index: 10;
  left: -1000px;
  top: 0px;
}
</style>

